import { useEffect, useRef } from 'react';
import { API_BASE_URL } from '../components/config';

export default function useAuditPageView(eventDetail) {
  const firedRef = useRef(false);

  useEffect(() => {
    if (!eventDetail || firedRef.current) return;
    firedRef.current = true;
    const token = localStorage.getItem('access');
    if (!token) return;
    fetch(`${API_BASE_URL}/api/audit/page-view/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ detail: eventDetail }),
    }).catch(() => {});
  }, [eventDetail]);
}
